/* eslint-disable */
import React, { memo, Suspense, useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./ProgramIndex.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { AppState } from "../../root/RootReducer";
import { ProgramDetail } from "../../stores/program/model/Program";
import {
  CircularProgress,
  Tab,
  Tabs,
  withStyles,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";
import { useNavigate, useParams } from "react-router-dom";
import ProgramPage from "./ProgramPage";
import useResponsive from "../../common/useResponsive";
import { useSuspenseQuery } from "@tanstack/react-query";
import { isNil } from "lodash";
import { useUpdateEffect } from "ahooks";


function a11yProps(index: any) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}
interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  className: string;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}
const DetailTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "var(--red)",
    },
  },
})((props: StyledTabsProps) => (
  <Tabs
    {...props}
    variant="scrollable"
    scrollButtons="on"
    textColor="secondary"
    TabIndicatorProps={{ children: <span /> }}
  />
));
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    tabs: {
      minWidth: "50px",
      padding: "6px 12px",
      marginRight: "46px",
      textTransform: "none",
    },
    tabsMobile: {
      minWidth: "50px",
      padding: "6px 12px",
      marginRight: "16px",
      textTransform: "none",
    },
  })
);
function ProgramIndexWrapper() {
      const { userInfo } = useSelector((state: AppState) => ({
    userInfo: state.user.userInfo,
  }));
 return <Suspense fallback={<div className={styles.noContent}>
        <CircularProgress size={60} style={{ color: "var(--red)" }} />
      </div>}>
    {isNil(userInfo?.id) ? null : <ProgramIndexV2 />}
    </Suspense>
}
function ProgramIndexV2() {
      const { userInfo } = useSelector((state: AppState) => ({
    userInfo: state.user.userInfo,
  }));
    const { data:allProgramList = [] } = useSuspenseQuery<ProgramDetail[]>({
      queryKey:['/api/getAllProgram',{
          params:{userId:userInfo?.id,}
      }],
  })

    const classes = useStyles();

  const match = useParams<{ id: string }>();
  const navigate = useNavigate();
    // プログラム一覧リスト
  const [tabIndex, setTabIndex] = React.useState<number>(() => {
    const idx = allProgramList.findIndex(item => item.id === match.id);
    return idx === -1 ? 0 : idx;
  });
  const channel = useMemo(() => {
      return allProgramList[tabIndex];
  },[allProgramList,tabIndex]);
  useUpdateEffect(() => {
    const idx = allProgramList.findIndex(item => item.id === match.id);
    setTabIndex(idx === -1 ? 0 : idx);
  }, [match.id,allProgramList]);

    const { isMobile } = useResponsive();
      // ヘッダー
  const { header } = useSelector((state: AppState) => ({
    header: state.header,
  }));
  const direction = header.direction === "left" ? -1 : 1;
    const handleChange = (event: React.ChangeEvent<{}>, index: number) => {
    navigate("/channel/" + allProgramList[index].id);
  };
  console.log("render ProgramIndexV2",allProgramList);
  return <AnimatePresence>
            <DetailTabs
          value={tabIndex}
          onChange={handleChange}
          className={styles.fixtabs}
          aria-label="Detail Tabs"
        >
          {allProgramList.length > 0 &&
            allProgramList.map((row, index) => (
              <Tab
                label={<b>{row.title}</b>}
                wrapped={true}
                key={row.id}
                className={isMobile ? classes.tabsMobile : classes.tabs}
                {...a11yProps(index)}
              />
            ))}
        </DetailTabs>
      <motion.div
        initial={{ x: 300 * direction, opacity: 0.3 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -300 * direction, opacity: 0 }}
        className={styles.root}
      >

                   {channel && <ProgramPage
                    key={channel?.id}
              channel={channel}
            />}
      </motion.div>
    </AnimatePresence>

}
export default memo(ProgramIndexWrapper);
